"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStyles = exports.mergeStyles = exports.useStyles = void 0;
var videoStyles_1 = require("./videoStyles");
Object.defineProperty(exports, "useStyles", { enumerable: true, get: function () { return videoStyles_1.useStyles; } });
Object.defineProperty(exports, "mergeStyles", { enumerable: true, get: function () { return videoStyles_1.mergeStyles; } });
Object.defineProperty(exports, "makeStyles", { enumerable: true, get: function () { return videoStyles_1.makeStyles; } });
//# sourceMappingURL=index.js.map